import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Home", id: "home" },
  { label: "La Novela", id: "la-novela" },
  { label: "La Película", id: "la-pelicula" },
  { label: "Proyecto Niñagordita", id: "proyecto" },
  { label: "Aliados", id: "aliados" },
  { label: "Cómo contribuir", id: "contribuir" },
  { label: "Nosotras", id: "nosotras" },
  { label: "NG Films", id: "ng-films" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled || open ? "bg-[#F2EDE3]/95 backdrop-blur-md border-b border-[#e2dccd]" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-[68px] flex items-center justify-between">
        <button
          data-testid="logo-home"
          onClick={() => go("home")}
          className="flex items-center"
          aria-label="Niñagordita - inicio"
        >
          <img
            src="/ninagordita-title.png?v=3"
            alt="NIÑAGORDITA"
            className="h-5 sm:h-6 w-auto"
            draggable={false}
          />
        </button>

        <ul className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <li key={l.id}>
              <button
                data-testid={`nav-${l.id}`}
                onClick={() => go(l.id)}
                className="text-sm font-medium text-[#141414] hover:text-[#C20A78] transition-colors duration-200"
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-[#C20A78]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menú"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-[#e2dccd] bg-[#F2EDE3]" data-testid="nav-mobile-menu">
          <ul className="px-5 py-4 flex flex-col">
            {LINKS.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`nav-mobile-${l.id}`}
                  onClick={() => go(l.id)}
                  className="w-full text-left py-3 text-base font-medium text-[#141414] hover:text-[#C20A78] transition-colors"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}
